/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        'html, body': {
            backgroundColor: 'white',
            color: 'gray.900'
        },
        body: {
            color: 'black',
            backgroundColor: 'white',
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: '300'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        }
    }
}
